import { ChangeDetectorRef, Component, computed, inject, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FonctionsService } from './services/fonctions-partagees.service';
import { TraductionService } from './services/traduction.service';
import { UtilisateurService } from './services/utilisateur.service';
import { KeycloakUtilisateur } from './bo/user/user';
import { KeycloakProfile } from 'keycloak-js';
import { NgSelectConfig } from '@ng-select/ng-select';
import { DeviceService } from './services/device.service';
import { NavLeftService } from './services/nav-left.service';
import { PosthogService } from './services/posthog.service';

type DeviceType = 'desktop' | 'mobile';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})

export class AppComponent {
  
  isSidebarVisible = signal(false);
  loading = signal(false);
  keycloakUtilisateur = signal<KeycloakUtilisateur | null>(null);
  userProfil = signal<KeycloakProfile | null>(null);

  protected device  = inject(DeviceService);
  protected navLeft = inject(NavLeftService);

  constructor(
     private readonly router: Router,
     private readonly tradService: TraductionService,
     private readonly config: NgSelectConfig,
     public fonctionsService: FonctionsService,
     public utilisateurService: UtilisateurService,
     private readonly cdref: ChangeDetectorRef,
     posthogService: PosthogService,
     ) {

    //Permet d'afficher des traductions sur les éléments des ng-select utilisés dans l'application
    tradService.translate.get(['GLOBAL.NO_ITEM_FOUND', 'GLOBAL.CLEAR_ALL', 'GLOBAL.AJOUTER']).subscribe(traduction => {
      config.notFoundText = traduction['GLOBAL.NO_ITEM_FOUND'];
      config.clearAllText = traduction['GLOBAL.CLEAR_ALL'];
      config.addTagText = traduction['GLOBAL.AJOUTER'];
    });
  }

   ngOnInit() {
    this.syncBodyThemeClass();

    // Permet de cacher les toasts affichés lorsque l'on change de route
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      this.syncBodyThemeClass();

      document.getElementById("toast-error-personnalized")?.classList.remove('show');
      document.getElementById("toast-success-delete")?.classList.remove('show');
      document.getElementById("toast-success")?.classList.remove('show');
      document.getElementById("toast-error")?.classList.remove('show');
    });

  }

  ngDoCheck(){
    this.cdref.detectChanges();
  }

  shouldShowOldNavBars(): boolean {
    const url = this.router.url.split('?')[0];
    // Routes new-theme incluant leurs sous-routes
    // (/new_config = refonte v2 de la configuration ; /config reste old-theme)
    const routesWithNewNavBar = [
      '/area',
      '/new-profile',
      '/site',
      '/our-products',
      '/new_config',
    ];

    return !routesWithNewNavBar.some(route => url === route || url.startsWith(route + '/'));
  }

  isProfilePage(): boolean {
    const url = this.router.url.split('?')[0];
    return url === '/new-profile' || url.startsWith('/new-profile/')
      || url === '/our-products' || url.startsWith('/our-products/');
  }

  private syncBodyThemeClass(): void {
    const isOldTheme = this.shouldShowOldNavBars();
    document.body.classList.toggle('old-theme', isOldTheme);
    document.body.classList.toggle('new-theme', !isOldTheme);
  }

  }

